import * as React from "react";
import { Link } from "react-router-dom";
import { computePrivilege } from "../../util";

interface IProps {
  className?: string;
  children: React.ReactNode;
  to: string;
  onClick: () => void;
  requiredPrivilege: string;
  showSetting: number;
}

const NavLink = ({
  className,
  children,
  to,
  onClick,
  requiredPrivilege,
  showSetting,
}: IProps) => {
  return computePrivilege(requiredPrivilege, showSetting) ? (
    <Link to={to}>
      <li className={className || ""} onClick={onClick}>
        {children}
      </li>
    </Link>
  ) : null;
};

export default NavLink;
